import { Provider as JotaiProvider } from 'jotai';
// import Cookies from 'js-cookie';
// import { DevTools } from 'jotai-devtools';
import { QueryClient, QueryClientProvider } from 'react-query';
// import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';
import 'jotai-devtools/styles.css';

import AppRouter from '@/router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // elimino el reintento de requests
    },
  },
});
function App() {
  return (
    <JotaiProvider>
      {/* <DevTools /> */}
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </JotaiProvider>
  );
}

export default App;
